import { UserAgentApplication } from "msal";

export class AuthService {
  constructor(clientId, authority, scopes) {
    this.applicationConfig = {
      clientid: clientId,
      authority: authority,
      scopes: scopes
    };
    this.app = new UserAgentApplication({
      auth: {
        clientId: this.applicationConfig.clientid,
        authority: this.applicationConfig.authority,
        redirectUri: `${window.location.protocol}//${window.location.host}`
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
      }
    });

    this.renew = setInterval(() => {
      var user = JSON.parse(localStorage.getItem("user"));
      if (!user) {
        return;
      }

      this.renewToken()
        .then(token => token, () => this.getToken())
        .then(
          token => {
            var user = JSON.parse(localStorage.getItem("user")) || token;
            user.access_token = token.accessToken || token.access_token;
            localStorage.setItem("user", JSON.stringify(user));
          },
          err => {
            console.warn("Could not renew authentication: " + err); // eslint-disable-line no-console
          }
        );
    }, 25 * 60 * 1000);
  }

  // Core Functionality
  loginPopup() {
    let requestObj = {
      scopes: this.applicationConfig.scopes,
      client_id: this.applicationConfig.clientid
    };
    var app = this.app;
    return app.loginPopup(requestObj).then(
      () => {
        return true;
      },
      () => {
        return null;
      }
    );
  }

  loginRedirect() {
    this.app.loginRedirect(this.applicationConfig);
  }

  logout() {
    this.app._user = null;
    this.app.logout();
  }

  renewToken() {
    let requestObj = {
      scopes: this.applicationConfig.scopes
    };

    return this.app.acquireTokenSilent(requestObj);
  }

  getToken() {
    let requestObj = {
      scopes: this.applicationConfig.scopes
    };

    return this.app.acquireTokenSilent(requestObj).then(
      accessToken => {
        return accessToken;
      },
      //errcode => {
      // const requiresInteraction = [
      //   "consent_required",
      //   "interaction_required",
      //   "login_required"
      // ];
      // var isInteractionRequired = requiresInteraction.indexOf(errcode.errorCode) >= 0;
      // if (!isInteractionRequired) {
      //   throw errcode;
      // }
      () => {
        return this.app.acquireTokenPopup(requestObj).then(
          accessToken => {
            return accessToken;
          },
          err => {
            throw err;
          }
        );
      }
    );
  }

  // Utility
  getUser() {
    return this.app.getUser();
  }
}
